import { IComboGroupContext, IFilterValues } from './comboGroupContext';

export enum ComboGroupActionTypes {
	SET_COMBO_GROUPS = 'SET_COMBO_GROUPS',
	CHANGE_SEARCH_STRING = 'CHANGE_SEARCH_STRING',
	SET_ID_SELECTED_CUSTOMER = 'SET_ID_SELECTED_CUSTOMER',
	SET_ID_SELECTED_RESTAURANT = 'SET_ID_SELECTED_RESTAURANT',
	SET_ID_SELECTED_DISH = 'SET_ID_SELECTED_DISH',
	RESET_SELECTED_CONTROLS = 'RESET_SELECTED_CONTROLS',
	SET_SORT_BY = 'SET_SORT_BY',
	SET_COUNT_OF_ITEMS = 'SET_COUNT_OF_ITEMS',
	CHANGE_CURRENT_PAGE = 'CHANGE_CURRENT_PAGE',
	SET_ID_FOR_DELETION = 'SET_ID_FOR_DELETION',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	SET_FILTERS_FROM_QUERY_STRING = 'SET_FILTERS_FROM_QUERY_STRING',
}

interface ISetComboGroups {
	type: ComboGroupActionTypes.SET_COMBO_GROUPS;
	payload: {
		comboGroups: IComboGroupContext['comboGroups'];
		typeOfModalWindow: IComboGroupContext['typeOfModalWindow'];
	};
}

interface IChangeSearchString {
	type: ComboGroupActionTypes.CHANGE_SEARCH_STRING;
	payload: {
		searchString: IComboGroupContext['searchString'];
	};
}

interface ISetIDCustomer {
	type: ComboGroupActionTypes.SET_ID_SELECTED_CUSTOMER;
	payload: {
		IDSelectedCustomer: IComboGroupContext['IDSelectedCustomer'];
	};
}

interface ISetIDRestaurant {
	type: ComboGroupActionTypes.SET_ID_SELECTED_RESTAURANT;
	payload: {
		IDSelectedRestaurant: IComboGroupContext['IDSelectedRestaurant'];
	};
}

interface ISetIDDish {
	type: ComboGroupActionTypes.SET_ID_SELECTED_DISH;
	payload: {
		IDSelectedDish: IComboGroupContext['IDSelectedDish'];
	};
}

interface IResetSelectedControls {
	type: ComboGroupActionTypes.RESET_SELECTED_CONTROLS;
}

interface ISetSortBy {
	type: ComboGroupActionTypes.SET_SORT_BY;
	payload: {
		sortBy: IComboGroupContext['sortBy'];
	};
}

interface ISetCountOfItems {
	type: ComboGroupActionTypes.SET_COUNT_OF_ITEMS;
	payload: {
		countOfItems: IComboGroupContext['countOfItems'];
	};
}

interface IChangeCurrentPage {
	type: ComboGroupActionTypes.CHANGE_CURRENT_PAGE;
	payload: {
		currentPage: IComboGroupContext['currentPage'];
	};
}

interface ISetIDForDeletion {
	type: ComboGroupActionTypes.SET_ID_FOR_DELETION;
	payload: {
		IDForDeletion: IComboGroupContext['IDForDeletion'];
		typeOfModalWindow: IComboGroupContext['typeOfModalWindow'];
	};
}

interface IChangeTypeOfModalWindow {
	type: ComboGroupActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: IComboGroupContext['typeOfModalWindow'];
	};
}

interface ISetFiltersFromQueryString {
	type: ComboGroupActionTypes.SET_FILTERS_FROM_QUERY_STRING;
	payload: {
		filters: IFilterValues;
	};
}

export type TComboGroupAction =
	| ISetComboGroups
	| IChangeSearchString
	| ISetIDCustomer
	| ISetIDRestaurant
	| ISetIDDish
	| IResetSelectedControls
	| ISetSortBy
	| ISetCountOfItems
	| IChangeCurrentPage
	| ISetIDForDeletion
	| IChangeTypeOfModalWindow
	| ISetFiltersFromQueryString;
